import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetPolicy = (policyId) => axios.get(`${apiPaths.policiesBase}/${policyId}`);

const onCreatePolicy = (policy) => axios.post(apiPaths.policiesBase, policy);
const onUpdatePolicy = (policy) => axios.put(apiPaths.policiesBase, policy);
const onDeletePolicy = (params) => axios.post(`${apiPaths.policiesBase}/delete-many`, params);

export { onGetPolicy, onCreatePolicy, onDeletePolicy, onUpdatePolicy };
